var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "payment-confirmed" }, [
    _c("header", { staticClass: "absolute" }, [
      _c(
        "a",
        {
          attrs: {
            href: _vm.ctaRedirectTo.path,
            title: _vm.ctaRedirectTo.title
          }
        },
        [
          _c("SaasIcon", {
            staticClass: "ml-2 mt-2 secondary-blue",
            attrs: { icon: "svgLogoSellsyText", width: 118, height: 28 }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "section",
      { staticClass: "flex-column hp-10 jc-center ai-center" },
      [
        _c("SaasIcon", {
          attrs: { icon: "svgCheck", width: 171, height: 162 }
        }),
        _vm._v(" "),
        _c("h1", { staticClass: "payment-confirmed-title" }, [
          _vm._v(
            "\n            " +
              _vm._s(_vm.$l10n.__("Merci de vous être abonné à Sellsy !")) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "payment-confirmed-subtitle" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Un email de confirmation vient de vous être envoyé."
                )
              ) +
              "\n        "
          )
        ]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "payment-confirmed-cta",
            attrs: {
              href: _vm.ctaRedirectTo.path,
              title: _vm.ctaRedirectTo.title
            }
          },
          [
            _c("CompassButton", {
              staticClass: "wp-10 px-4 fs-4 lh-24",
              attrs: {
                label: _vm.ctaRedirectTo.btnLabel,
                type: "primary",
                size: "large"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c("p", {
          staticClass: "payment-confirmed-help",
          domProps: {
            innerHTML: _vm._s(
              _vm.$t.__("pages.subscription.need_help", {
                startLinkHelp:
                  "<a class='fs-4 link' href='https://help.sellsy.com' target='_blank'>",
                startLinkContact:
                  "" +
                  (_vm.isConnected
                    ? "<a class='fs-4 link' onclick='MySupport.getForm()'>"
                    : "<a class='fs-4 link' href='https://go.sellsy.com'>"),
                endLink: "</a>"
              })
            )
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }